import styled from 'styled-components';

const FullPage = styled.div`
    height: 100%;
    background-color: #182c3e;
    color: #ffffff;
    grid-column: page-start / page-end;
    grid-row: page-top / page-bottom;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;

export default FullPage;
